export default {
    direct: 'direct',
    batch: 'batch',
    email: 'email',
    blocked: 'blocked'
}
